import { useState } from 'react';
import { EXPORT_TAB_VIEW } from '../../constants/ScanOptionText';
import MyExportOptions from './MyExportOptions';
import MySBOMOptions from './MySBOMOptions';
//import { useTranslation } from 'react-i18next'
import './MyExportView.css';

function MyExportView() {
  const [viewType, setViewType] = useState(EXPORT_TAB_VIEW.CLARITY);
  //const { t } = useTranslation()

  const activeStyle = {
    color: '#7434fe',
    opacity: 1,
  };
  /** Clarity SBOM | External SBOM */

  return (
    <div id="MyConnectionsView">
      <div className="contents_header">
        <div className="contents_header_sub">
          <div className="contents_header_inner">
            <a
              className="content_title"
              style={{
                cursor: 'pointer',
                ...(viewType === EXPORT_TAB_VIEW.CLARITY
                  ? activeStyle
                  : undefined),
              }}
              onClick={() => {
                return viewType !== EXPORT_TAB_VIEW.CLARITY
                && setViewType(EXPORT_TAB_VIEW.CLARITY);
              }}
              onKeyUp={() => {
                return viewType !== EXPORT_TAB_VIEW.CLARITY
                && setViewType(EXPORT_TAB_VIEW.CLARITY);
              }}
            >
              Clarity SBOM
            </a>
          </div>
          <div className="contents_header_inner">
            <a
              className="content_title"
              style={{
                cursor: 'pointer',
                ...(viewType === EXPORT_TAB_VIEW.SBOM
                  ? activeStyle
                  : undefined),
              }}
              onClick={() => {
                return viewType !== EXPORT_TAB_VIEW.SBOM
                && setViewType(EXPORT_TAB_VIEW.SBOM);
              }}
              onKeyUp={() => {
                return viewType !== EXPORT_TAB_VIEW.SBOM
                && setViewType(EXPORT_TAB_VIEW.SBOM);
              }}
            >
              CycloneDX
            </a>
          </div>
        </div>
      </div>
      {viewType === EXPORT_TAB_VIEW.CLARITY ? (
        <MyExportOptions />
      ) : (
        <MySBOMOptions />
      )}
    </div>
  );
}
export default MyExportView;
